/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from "react";
import { FieldErrors, GlobalError } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ObjectShape } from "yup";
import * as yup from "yup";

import { getYupLocale, Log, RydeUiUnit } from "@ryde/shared";

type FormValidationResult = {
  values: any;
  errors: FieldErrors;
};

export type FormValidationReturnResult = (
  data: any,
) => Promise<FormValidationResult>;

type CustomValidationError = GlobalError & { path: string };

export const useYupValidationResolver = (
  validationSchema: ObjectShape | undefined,
  entity?: RydeUiUnit,
): FormValidationReturnResult => {
  const { t } = useTranslation();
  return useCallback(
    async (data: any): Promise<FormValidationResult> => {
      try {
        yup.setLocale(getYupLocale(entity, t));

        const schemeFinal = yup.object().shape(validationSchema || {});
        const values = await schemeFinal.validate(data, {
          abortEarly: false,
        });
        Log.debug("YUP, form validation SUCCESSFUL, validated values:", values);
        return {
          values,
          errors: {},
        };
      } catch (errors: any) {
        if (!errors.inner) {
          Log.debug(`YUP form validating, unknown errors:`, errors);
          throw errors;
        }

        const aggregatedErrors = errors.inner.reduce(
          (allErrors: FieldErrors, currentError: CustomValidationError) => {
            return {
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? "validation",
                message: currentError.message,
              },
            };
          },
          {},
        );
        Log.debug(
          `YUP form validating NOT successful,errors:`,
          aggregatedErrors,
        );
        return {
          values: {},
          errors: aggregatedErrors,
        };
      }
    },
    [entity, t, validationSchema],
  );
};
